export default __webpack_public_path__ + "58d4fa558a44feebbedc1002f80030ac.svg";